const SilverBase = require('silver-base');

const GoldLog = require('@ali/silver-gold-log');
const WdmLog = require('@ali/silver-wdm-log');
/**
 * SilverUniteLog
 * @class
 */
export class SilverUniteLog extends SilverBase {
  constructor(opt) {
    super(opt);

    if (opt) {
      this.code = opt.code;
      this.key = opt.key;
    }
    this.gold = null;
    this.wdm = new WdmLog();

    this.data = {};
    this._makeData();
    this.init();
    this.setGlobal();
  }
  /**
   * getName 获取组件名称
   * @memberOf SilverUniteLog.prototype
   * @method getName
   * @return {String}
   */
  getName() {
    return 'SilverUniteLog';
  }

  init() {
    if (this.code && this.key) {
      this.gold = new GoldLog({
        code: this.code,
        key: this.key
      });
    }
  }

  _makeData() {
    this.data.act_url = window.location.href;
    this.data.act_name = window.document.title;
    if (!window.tv) {
      return;
    }
    if (window.tv.getUUid) {
      this.data.uuid = window.tv.getUUid();
    }
    if (window.tv.getLoginID) {
      const nick = window.tv.getLoginID();
      if (nick) {
        this.data.is_login = true;
        this.data.user_id = nick;
      }
    }
    if (window.tv.getYoukuLoginInfo) {
      let use = window.tv.getYoukuLoginInfo();
      if (use) {
        try {
          use = JSON.parse(use);
        } catch (e) {
          use = {};
        }
      } else {
        use = {};
      }
      if (use.userName) {
        this.data.is_login_from_youku = true;
        this.data.youku_name = use.userName;
        this.data.youku_id = use.ykID;
      }
    }
  }

  setGlobal(data) {
    if (data) {
      for (let k in data) {
        if (data.hasOwnProperty(k)) {
          this.data[k] = data[k];
        }
      }
    }

    if (this.gold) {
      this.gold.setGlobal(this.data);
    }
    this.wdm.setGlobal(this.data);
    return this;
  }

  exposure(data) {
    if (this.gold) {
      this.gold.exposure(data);
    }
    const eventId = data.eventId || data.event_id || data.eventName || data.event_name;
    if (!eventId) {
      return this;
    }
    this.wdm.event(eventId, data);
    return this;
  }

  event(data) {
    if (this.gold) {
      this.gold.event(data);
    }
    const eventId = data.eventId || data.event_id || data.eventName || data.event_name;
    if (!eventId) {
      return this;
    }
    this.wdm.event(eventId, data);
    return this;
  }
}



// WEBPACK FOOTER //
// ./~/@ali/silver-unite-log/lib/index.js